// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__bFwN0","title":"FrontImage_title__2iZZR"};